import { useAlert } from 'dashboard/composables';

// Error markers the modals already render once a save was attempted: an input
// with the red `!border-red-500` border, or the red `p.text-red-500` message
// under a field. querySelector with a selector list returns the first match in
// document order, i.e. the topmost invalid field.
const FIRST_ERROR_SELECTOR = '.\\!border-red-500, p.text-red-500';

// Scrolls the modal (or form) to its first invalid field so a blocked save is
// never silent when that field is off screen. `vm` is the modal instance.
export function scrollToFirstError(vm) {
  vm.$nextTick(() => {
    const target = vm.$el.querySelector(FIRST_ERROR_SELECTOR);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (target.matches('input, select, textarea')) {
      target.focus({ preventScroll: true });
    }
  });
}

// Called when Save is pressed but validation fails: tells the user why nothing
// happened and brings the first invalid field into view.
export function reportInvalidForm(vm) {
  useAlert(vm.$t('REAL_ESTATE.FORM.FIX_ERRORS'));
  scrollToFirstError(vm);
}
